import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { CompanyData } from '../../types/inpi';
import AnnualAccountsCard from '../inpi/AnnualAccountsCard';
import LegalActsCard from '../inpi/LegalActsCard';

interface GovernanceSectionProps {
  companyData: CompanyData | null;
  companyLoading: boolean;
  companyError: string | null;
  annualAccounts: any;
  annualAccountsLoading: boolean;
  annualAccountsError: string | null;
  legalActs: any;
  legalActsLoading: boolean;
  legalActsError: string | null;
  onAnnualAccountsPageChange: (page: number) => void;
  onLegalActsPageChange: (page: number) => void;
}

const GovernanceSection: React.FC<GovernanceSectionProps> = ({
  companyData,
  companyError,
  annualAccounts,
  annualAccountsLoading,
  annualAccountsError,
  legalActs,
  legalActsLoading,
  legalActsError,
  onAnnualAccountsPageChange,
  onLegalActsPageChange
}) => {
  // Check only for critical error
  const hasCriticalError = companyError && !companyData;

  // Render error state
  if (hasCriticalError) {
    return (
      <div className="bg-white shadow rounded-lg overflow-hidden">
        <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b border-gray-200">
          <h3 className="text-lg font-medium leading-6 text-gray-900">
            Documents légaux
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">
            Données issues de l'INPI
          </p>
        </div>
        <div className="p-6">
          <div className="bg-red-50 border border-red-200 rounded-md p-4 text-sm text-red-600">
            {companyError || "Impossible de charger les données. Veuillez réessayer plus tard."}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white shadow rounded-lg overflow-hidden">
      <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b border-gray-200">
        <h3 className="text-lg font-medium leading-6 text-gray-900">
          Documents légaux
        </h3>
        <p className="mt-1 max-w-2xl text-sm text-gray-500">
          Données issues de l'INPI
        </p>
      </div>
      
      <div className="p-6 space-y-8">
        {/* Annual Accounts */}
        <div>
          <h4 className="text-lg font-medium text-gray-800 mb-4">Comptes annuels</h4>
          <AnnualAccountsCard 
            annualAccounts={annualAccounts} 
            isLoading={annualAccountsLoading} 
            error={annualAccountsError}
            onPageChange={onAnnualAccountsPageChange}
          />
        </div>
        
        {/* Legal Acts */}
        <div className="pt-6 border-t border-gray-200">
          <h4 className="text-lg font-medium text-gray-800 mb-4">Actes juridiques</h4>
          <LegalActsCard 
            legalActs={legalActs} 
            isLoading={legalActsLoading} 
            error={legalActsError}
            onPageChange={onLegalActsPageChange}
            companyData={companyData}
          />
        </div>
      </div>
    </div>
  );
};

export default GovernanceSection; 